import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder,
  SerializedData, cloneDataOrNull, isSameData } from '../dto/dto.js';
import { Locality } from './locality.js';
import { PhoneNumber } from './phone-number.js';

export class FestivalRaffleEntry extends DataModel {
  static readonly TYPE_ID: string = 'fa31d3c7e8664e09b1e3db715cd01acc';

  constructor(
    public readonly uniqueId: string,
    public readonly userId: string | null,
    public readonly name: string,
    public readonly phoneNumber: PhoneNumber,
    public readonly locality: Locality | null,
  ) {
    super();
  }

  get $typeId(): string {
    return FestivalRaffleEntry.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FestivalRaffleEntry {
    let encodedPhoneNumber = MapUtils.get<string>(map, 'phoneNumber');
    encodedPhoneNumber = encodedPhoneNumber.replace(/ /g, '');

    return new FestivalRaffleEntry(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.getOrNull<string>(map, 'userId'),
        MapUtils.get<string>(map, 'name'),
        PhoneNumber.mustDecode(encodedPhoneNumber),
        context.fromDataOrNull<Locality>(MapUtils.getOrNull<SerializedData>(map, 'locality')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'userId': this.userId,
      'name': this.name,
      'phoneNumber': this.phoneNumber.encode(),
      'locality': context.toDataOrNull(this.locality),
    };
  }

  clone(): this {
    return new FestivalRaffleEntry(
        this.uniqueId,
        this.userId,
        this.name,
        this.phoneNumber.clone(),
        cloneDataOrNull(this.locality),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.userId === this.userId &&
        other.name === this.name &&
        isSameData(other.phoneNumber, this.phoneNumber) &&
        isSameData(other.locality, this.locality);
  }
}

export class FestivalRaffleEntryBuilder extends DataModelBuilder<FestivalRaffleEntry> {
  build(context: SerializationContext, map: SerializedData): FestivalRaffleEntry {
    return FestivalRaffleEntry.fromMap(context, map);
  }
}
